import {
  request
} from './https.js'
 

// 列表查询接口
export const login = (param) => {
  return request({
    url: '/api/v1/users/actions/login',
    method: 'post',
    data: param
  })
};
export const yzm = (param) => {
  return request({
    url: '/api/v1/captcha/yzm',
    method: 'get',
    data: param
  })
};


// WEBPACK FOOTER //
// ./src/api/api.js